<template>
  <div class="drafts common-style">
    <!-- <div class="drafts-header">1</div> -->
    <div class="drafts-main">
      <div v-if="!empty" class="drafts-list">
        <div class="drafts-list-item" v-for="(item, index) in draftsList" :key="index">
          <div class="title">
            <span>
              <img :src="pic" alt />
            </span>
            <h3>{{ item.title }}</h3>
            <a-tooltip placement="top" v-if="item.description">
              <template slot="title">
                <span>作业备注：{{ item.description }}</span>
              </template>
              <i class="sigh">
                <img class="three" src="../../assets/images/sigh.svg" alt />
              </i>
            </a-tooltip>

            <a-tooltip placement="top" v-else>
              <i class="sigh">
                <img class="three" src="../../assets/images/sigh.svg" style="visibility:hidden" />
              </i>
            </a-tooltip>
          </div>
          <div>
            <span>共&nbsp;{{ item.quesnum }}&nbsp;个题</span>
            <span>
              保存时间：{{
              item.createdate | dateFormat("YYYY-mm-dd HH:MM")
              }}
            </span>
            <span>
              <a @click="showDrawer(item)">预览</a>
              <a @click="showPublishModal(item)">发布</a>
              <a style="color:#ff4d4f" @click="deleteHomeWork(item)">删除</a>
            </span>
          </div>
        </div>
      </div>

      <template v-else>
        <!-- <a-empty description="暂无数据" /> -->
        <div class="empty">
          <img src="../../assets/images/noData.png" alt />
        </div>
      </template>
    </div>
    <div class="drafts-footer">
      <a-locale-provider :locale="zhCN">
        <a-pagination
          size="small"
          :pageSize.sync="pagination.pagesize"
          :default-current="pagination.page"
          :total="totalCount"
          :current="currentPage"
          show-quick-jumper
          @change="paginationChange"
          @showSizeChange="showSizeChange"
        />
      </a-locale-provider>
    </div>

    <!-- 右侧滑出查看试题 -->

    <a-drawer
      width="75vw"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
      wrapClassName="question-preview"
    >
      <div class="anchor">
        <div class="title">{{ title }}</div>

        <div>
          <span @click="showPublishModal(currentItem)" style="padding:6px 20px">发布</span>
          <span v-if="showAll == true" @click="addTestCarAll()">全部加入试题篮</span>
          <span
            v-if="showAll == false"
            @click="deleteTestCarAll()"
            style="color:#FF6700;border:1px solid #FF6700"
          >全部移出试题篮</span>
        </div>
      </div>
      <div>
        <div
          :id="index + 1"
          class="question-preview-item"
          v-for="(item, index) in questionList"
          :key="index"
        >
          <a-collapse accordion :activeKey="curIndex" @change="changeActivekey(item, $event)">
            <a-collapse-panel :key="index" :show-arrow="false">
              <template slot="header">
                <div>
                  <div class="titleContent">
                    <p class="lastC" v-html="item.stem"></p>
                  </div>
                  <div style="padding-left:22px;clear:both">
                    <div class="typeAll">
                      <p class="inspect">
                        <span class="van-multi-ellipsis--l2">
                          考察：{{
                          item.knowledgePoints == ""
                          ? "未设置"
                          : item.knowledgePoints
                          }}
                        </span>
                        <span>难度：{{ item.difficulty }}</span>
                      </p>
                      <p class="inspect">
                        <span>题号：{{ item.sid }}</span>
                        <span>题型：{{ item.typeName }}</span>
                      </p>
                      <div class="shopHoverss">
                        <span v-if="item.showAdd == true" @click.stop="addTestCar(item)">加入试题篮</span>
                        <span
                          v-if="item.showAdd == false"
                          style="color:#FF6700;border:1px solid #FF6700"
                          @click.stop="deleteTestCar(item)"
                        >移出试题篮</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="answer">
                <p>
                  <span>答案：</span>
                  <span v-html="item.answer"></span>
                </p>
                <p>
                  <span>解析：</span>
                  <span v-html="item.explanation"></span>
                </p>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>

      <!-- 试题蓝 -->
      <div v-if="visible" class="drafts-testShop">
        <a-dropdown placement="topRight">
          <a class="testShop">
            <img src="../../assets/images/testBasket.png" alt />
            <span>{{ getLocalData.length }}</span>
          </a>
          <a-menu slot="overlay" class="dropList">
            <a-menu-item>
              <ul v-if="!noTestQuestions" class="cart-list">
                <li v-for="(item, index) in shopList" :key="index">
                  <p class="p1">{{ index }}：</p>
                  <p class="p2">{{ item }}题</p>
                </li>
              </ul>
              <div v-if="noTestQuestions" class="notestPop">暂无试题，请去添加喔！</div>
              <p>
                <a class="testStyle" @click="goAssembly()">进入试题篮</a>
                <a class="emptyStyle" @click="clear()">清空试题篮</a>
              </p>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-drawer>

    <!-- 试题蓝 -->
    <div v-if="!visible" class="drafts-testShop">
      <a-dropdown placement="topRight">
        <a class="testShop">
          <img src="../../assets/images/testBasket.png" alt />
          <span>{{ getLocalData.length }}</span>
        </a>
        <a-menu slot="overlay" class="dropList">
          <a-menu-item>
            <ul v-if="!noTestQuestions" class="cart-list">
              <li v-for="(item, index) in shopList" :key="index">
                <p class="p1">{{ index }}：</p>
                <p class="p2">{{ item }}题</p>
              </li>
            </ul>
            <div v-if="noTestQuestions" class="notestPop">暂无试题，请去添加喔！</div>
            <p>
              <a class="testStyle" @click="goAssembly()">进入试题篮</a>
              <a class="emptyStyle" @click="clear()">清空试题篮</a>
            </p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

    <a-modal
      width="850px"
      title="发布作业"
      v-model="publishVisible"
      @cancel="handleCancel"
      @ok="checkPublish"
      cancelText="取消"
      okText="确认"
      :bodyStyle="{
        overflow:'auto'
      }"
      centered
    >
      <publishAssembly
        ref="publishAssembly"
        :formData="formData"
        :pageList="pageList"
        :exercisetypeData="exercisetypeData"
        :isDrafts="isDrafts"
        v-if="publishVisible"
        v-on:incre="closePublishDialog"
      ></publishAssembly>
    </a-modal>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN"
import publishAssembly from "../testAssembly/model/publish-Assembly"
import data from "../../../src/config/assemblyJson"
import moment from "moment"
export default {
  name: "drafts",

  props: {},

  components: {
    publishAssembly,
  },

  computed: {},

  watch: {
    questionList: {
      handler (newValue) {
        console.log("newValue", newValue)
        newValue.forEach((item) => {
          item.showAdd = true
          this.getLocalData.forEach((item1) => {
            if (item1 == item.sid) {
              item.showAdd = false
            }
          })
        })
      },
      deep: true,
    },
  },

  inject: ["reload"],

  data () {
    return {
      differs: {
        UNSET: "未知",
        VERY_EASY: "容易",
        EASY: "较易",
        MODERATE: "中等",
        HARD: "较难",
        VERY_HARD: "困难",
      }, // 难易程度
      zhCN,
      pagination: {
        page: 1,
        pagesize: 6,
      },
      totalCount: 0,
      draftsList: [],
      pic: require("../../assets/images/drafts.png"),
      empty: false,
      currentPage: 1,
      visible: false,
      title: "",
      showAll: true,
      curIndex: 0,
      questionList: [],
      currentItem: {}, // 当前预览的作业信息
      getLocalData: [],
      childNum: "",
      structStr: {
        answerCardAlone: false, // 答题卡是否分离
        candidate:
          "姓名：__________学校：__________班级：__________准考证号：__________", // 密封性内文字
        candidateDisplay: true, // 是否显示密封线
        desc: "命卷人：XXX 考试范围：请设置", // 试卷描述
        descDisplay: true, // 是否显示描述
        gutterDisplay: true, // 分栏显示
        includeAnswer: false, // 是否包含答案
        includeAnswerCard: false, // 是否包含答题卡
        includeDetailTable: false, //
        includeExplanation: false, // 是否包含解析
        includeQRCode: false, // 是否显示二维码
        note:
          "注意事项：\n1、使用2B铅笔涂写客观题部分\n2、主观题请在有效答题区域内作答", // 注意事项
        noteDisplay: true, // 是否显示注意事项
        paperId: 0, // 是否再次编辑(默认0)
        paperSize: "A4", // 纸张大小
        paperType: "docx", // 输出类型
        partStructures: [
          {
            // 试卷结构体
            partDesc: "第I卷的注释", // 分卷备注
            partDescDisplay: true, // 是否显示分卷备注
            partName: "第I卷（客观题）", // 分卷标题
            partNameDisplay: true, // 是否显示分卷标题
            sectionStructures: [
              {
                // 题组
                sectionId: "8", // 题组(型)编号
                sectionName: "选择题", // 题目类型
                objectiveType: true, // 是否是客观题
                sectionDesc: "选择题说明。", // 题组说明
                sectionScore: 0, // 题组总分
                scoreDistribution: "", //
                sectionDescDisplay: true, // 是否显示题组说明
                sectionNameDisplay: true, // 是否显示题组名称
                quesStructures: [],
              },
            ],
          },
        ],
        quesIdList: [], // 废弃
        scoreTableDipsplay: true, // 是否显示誊分栏
        securityLabelDisplay: true, // 是否显示绝密字样
        style: "homework", // 作业样式
        subTitle: "", // 子标题
        subTitleDisplay: true, // 是否显示子标题
        title: "请输入标题", // 主标题
        totalScore: 0, // 总分值
      },
      quesStructures: [],
      noTestQuestions: false,
      shopList: [], //题目类型列表
      moment,
      publishVisible: false,
      formData: {
        id: 0, // 当前作业id，未发布的id为0，
        exercisetype: 4, // 作业类型 (课前导学...)
        exercisename: "请输入作业标题", // 作业标题
        exercisenote: "", // 作业备注
        execisepushtime: moment().format("YYYY-MM-DD HH:mm:ss"), // 发布时间
        execiseendtime: moment()
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm:ss"), // 截止时间
        completiontime: "60", // 预估完成作业时间
        classids: [], // 班级id集合
        studentids: [], //学生id集合
        classstudentids: [], // 班级学生id集合
        quesids: [], // 题目id集合
        bankid: "", // 学科id
        struct: {}, // 整个作业json
        totalscore: 0, // 总分
      },
      exercisetypeData: [], // 作业类型
      pageList: [],
      getPageListFlag: false,
      isDrafts: true,
    }
  },

  filters: {
    dateFormat (date, fmt) {
      date = new Date(date)
      let ret
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt)
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          )
        }
      }
      return fmt
    },
  },

  methods: {
    checkPublish () {
      this.$refs.publishAssembly.checkPublish() // 父组件调用子组件的方法
    },

    // 获取数据
    async getDraftsList () {
      let { data: res } = await this.$http.get(
        `/v1/learnonly/upload/draftpage`,
        {
          params: {
            teacherid: this.$store.getters.id,
            page: this.pagination.page,
            pagesize: this.pagination.pagesize,
          },
        }
      )
      // console.log(res)

      if (res.code != 200) {
        this.empty = false
        return this.$message.error(res.$message)
      }
      if (res.data.length > 0) {
        this.empty = false
      } else {
        this.empty = true
      }
      this.draftsList = res.data
      this.totalCount = res.length
    },

    //切换页数
    paginationChange (page, pageSize) {
      // console.log(page, pageSize)
      this.pagination.page = page
      this.currentPage = page
      this.pagination.pagesize = pageSize
      this.getDraftsList()
    },

    //切换条数
    showSizeChange (current, size) {
      // console.log(current, size)
      this.pagination.page = current
      this.pagination.pagesize = size
      this.getDraftsList()
    },

    // 删除作业
    deleteHomeWork (item) {
      var that = this
      this.$confirm({
        title: "删除草稿作业",
        content: (
          <p>
            作业 <span style="color:#F56C6C;padding:0 5px">{item.title}</span>
            将被删除，确定操作吗？
            <p style="color:#ff4d4f;margin-top:5px">
              警告：删除该作业后，不可恢复！
            </p>
          </p>
        ),
        maskClosable: true,
        centered: true,
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        icon: "close-circle",
        async onOk () {
          let { data: res } = await that.$http.get(
            "/v1/learnonly/upload/draftdelete",
            {
              params: {
                id: item.id,
              },
            }
          )
          if (res.code != 200) return this.$message.error(res.message)
          let index = that.draftsList.findIndex((ele) => {
            return ele.id == item.id
          })
          that.draftsList.splice(index, 1)

          if (that.draftsList.length == 0 && that.pagination.page > 1) {
            that.pagination.page--
            that.currentPage = that.pagination.page
          }
          that.getDraftsList()
          that.$message.success("作业 " + item.title + " 删除成功", 1)

          if (that.draftsList.length == 0) {
            that.empty = true
          }
        },
        onCancel () { },
      })
    },

    showDrawer (item) {
      this.visible = true
      this.currentItem = item

      this.title = item.title
      this.commonHandle(item)
      $("div.ant-drawer-wrapper-body").scrollTop(0)
    },

    commonHandle (item) {
      if (
        item.struct &&
        item.struct != null &&
        item.struct != undefined &&
        item.struct != "undefined"
      ) {
        let quesStructures = JSON.parse(
          item.struct
        ).partStructures[0].sectionStructures[0].quesStructures.map((item) => {
          return item.questionId
        })
        let idListStr = quesStructures.join(",")
        this.getQuesData(idListStr)
      }
    },

    // 判断数组中是否包含另一个数组
    isContained (aa, bb) {
      if (
        !(aa instanceof Array) ||
        !(bb instanceof Array) ||
        aa.length < bb.length
      ) {
        return false
      }
      for (var i = 0; i < bb.length; i++) {
        var flag = false
        for (var j = 0; j < aa.length; j++) {
          if (aa[j] == bb[i]) {
            flag = true
            break
          }
        }
        if (flag == false) {
          return flag
        }
      }

      return true
    },

    // 返回难度中文
    getDifficulty (d) {
      for (const i in this.differs) {
        if (Object.hasOwnProperty.call(this.differs, i)) {
          const item = this.differs[i]
          if (i == d) return item
        }
      }
    },

    // 根据试题id获取试题
    async getQuesData (idListStr) {
      var res = await this.$http.post(`v1/learnonly/zj/paper/loadques/sort`, {
        data: idListStr,
      })
      if (res.status === 200 && res.data !== null) {


        //判断预览的题目是否全部包含在试题篮中,如果全部在试题篮中,把全部加入试题篮改成全部移出
        let aa = this.questionList.map((item) => {
          return item.sid
        })

        this.showAll = !this.isContained(this.getLocalData, aa)
        res.data.forEach((item) => {
          item.showAnswer = false // 添加默认不展示答案属性
          item.difficulty = this.getDifficulty(item.experiencedDifficulty) // 添加一个中文困难度的属性
          if (item.typeId == 0) item.typeName = "未设置题型"
          var childNum =
            (item.stem.length - item.stem.replace(/sq-num/g, "").length) / 6
          if (childNum == 0) {
            childNum += 1
          }
          let obj = {
            questionId: item.sid,
            bankId: item.bankId,
            bankName: item.bankName,
            childNum: item.childNum,
            questionTypeId: item.typeId,
            questionTypeName: item.typeName,
            blankHeight: item.blankHeight ? item.blankHeight : 0,
            score: item.score ? item.score : 5,
            tip: item.tip ? item.tip : "",
            mark: item.mark,
          }
          this.structStr.partStructures[0].sectionStructures[0].quesStructures.push(
            obj
          )
        })
        this.questionList = res.data

        this.setPageList()
      } else {
        this.$message.error("暂无试题或获取题目失败")
      }
    },

    setPageList () {
      this.pageList = []
      console.log(this.quesStructures)
      this.questionList.forEach((q, i) => {
        var childNum =
          (q.stem.length - q.stem.replace(/sq-num/g, "").length) / 6
        if (childNum == 0) {
          childNum += 1
        }
        let obj = {
          questionId: q.sid,
          bankId: q.bankId,
          bankName: q.bankName,
          childNum: childNum,
          questionTypeId: q.typeId,
          questionTypeName: q.typeName,
          blankHeight: q.blankHeight ? q.blankHeight : 0,
          score: q.score ? q.score : 5,
          tip: "",
          mark: 0,
          tag: 0,
          stem: q.stem,
          knowledgePoints: q.knowledgePoints,
          experiencedDifficulty: q.experiencedDifficulty,
          index: i + 1,
          showAnswer: q.showAnswer,
          questNumName: q.questNumName
        }
        this.pageList.push(obj)
      })

      this.totalizeScore(this.pageList)
      this.getQuesId(this.pageList)
      this.formData.bankid = this.pageList[0].bankId
      this.formData.struct = this.structStr
      this.formData.struct.title = this.formData.exercisename
    },

    totalizeScore (data) {
      var totalScore = 0
      data.forEach((i) => {
        totalScore = totalScore + parseFloat(i.score)
      })
      this.formData.totalscore = totalScore
    },

    // 设置试题id
    getQuesId (data) {
      var quesIds = []
      data.forEach((i) => {
        quesIds.push(i.questionId)
      })
      this.formData.quesids = quesIds
    },

    // 关闭弹窗
    onClose () {
      this.visible = false
    },

    // 切换折叠面板
    async changeActivekey (item, key) {
      this.curIndex = key
      if (key && !item.explanation) {
        var { data: res } = await this.$http.get(
          `v1/learnonly/zj/question/answer?questionid=${item.sid}`
        )
        if (res) {
          item.explanation = res.explanation
          this.$forceUpdate()
        }
      }
    },

    // 全部加入试题蓝
    addTestCarAll () {
      var notJoin = []
      for (let i = 0; i < this.questionList.length; i++) {
        var items = this.questionList[i]
        if ($.inArray(items.sid, this.getLocalData) == -1) {
          notJoin.push(items.sid)
        }
      }
      var numLength =
        Number(this.quesStructures.length) + Number(notJoin.length)
      if (this.quesStructures.length < 60 && numLength <= 60) {
        for (let i = 0; i < this.questionList.length; i++) {
          var item = this.questionList[i]
          if ($.inArray(item.sid, this.getLocalData) == -1) {
            this.getLocalData.push(item.sid)
            var stem = item.stem
            var childNum =
              (stem.length - stem.replace(/sq-num/g, "").length) / 6
            if (childNum == 0) {
              childNum += 1
            }
            this.childNum = childNum
            this.quesStructures.push({
              bankName: item.bankName,
              questionId: item.sid,
              childNum: this.childNum,
              typeName: item.typeName == "" ? "未设置题型" : item.typeName,
            })
          }
          this.questionList[i].showAdd = false
          this.showAll = false
        }
        localStorage.setItem("localData", this.getLocalData)
        localStorage.setItem("localJson", JSON.stringify(this.quesStructures))
      } else {
        const key = "updatable"
        //通过唯一的key值来确保只出现一个提示
        this.$message.warning({
          content: "试题篮总数不得大于60题，建议您重新选取！",
          key,
          duration: 1.5,
        })
      }

      this.getNum()
    },

    // 全部移出
    deleteTestCarAll () {
      // 删除localData
      for (let i = 0; i < this.questionList.length; i++) {
        for (let j = 0; j < this.getLocalData.length; j++) {
          if (this.questionList[i].sid == this.getLocalData[j]) {
            this.getLocalData.splice(j, 1)
          }
        }
        for (let k = 0; k < this.quesStructures.length; k++) {
          if (this.questionList[i].sid == this.quesStructures[k].questionId) {
            this.quesStructures.splice(k, 1)
          }
        }
        this.questionList[i].showAdd = true
        this.showAll = true
      }
      localStorage.setItem("localData", this.getLocalData)
      localStorage.setItem("localJson", JSON.stringify(this.quesStructures))

      this.getNum()
    },

    // 单题加入移出试题蓝
    addTestCar (item) {
      if (this.quesStructures.length < 60) {
        this.getLocalData.push(item.sid)
        var stem = item.stem
        var childNum = (stem.length - stem.replace(/sq-num/g, "").length) / 6
        if (childNum == 0) {
          childNum += 1
        }
        this.childNum = childNum
        this.quesStructures.push({
          bankName: item.bankName,
          questionId: item.sid,
          childNum: this.childNum,
          typeName: item.typeName == "" ? "未设置题型" : item.typeName,
        })
        localStorage.setItem("localData", this.getLocalData)
        localStorage.setItem("localJson", JSON.stringify(this.quesStructures))
        var arr = []
        for (let i = 0; i < this.questionList.length; i++) {
          if (item.sid == this.questionList[i].sid) {
            this.questionList[i].showAdd = false
            this.$forceUpdate()
          }
          arr.push(this.questionList[i].showAdd)
          var flag = arr.some((item) => {
            return item === true
          })
          this.showAll = flag
        }
      } else {
        const key = "updatable"
        //通过唯一的key值来确保只出现一个提示
        this.$message.warning({
          content: "试题篮总数不得大于60题，建议您重新选取！",
          key,
          duration: 1.5,
        })
      }

      this.getNum()
    },

    // 单题移出试题篮
    deleteTestCar (item) {
      // 删除localData
      for (let j = 0; j < this.getLocalData.length; j++) {
        if (item.sid == this.getLocalData[j]) {
          this.getLocalData.splice(j, 1)
        }
      }
      localStorage.setItem("localData", this.getLocalData)
      // 删除localJson
      for (let k = 0; k < this.quesStructures.length; k++) {
        if (item.sid == this.quesStructures[k].questionId) {
          this.quesStructures.splice(k, 1)
        }
      }
      localStorage.setItem("localJson", JSON.stringify(this.quesStructures))
      var arr = []
      for (let i = 0; i < this.questionList.length; i++) {
        if (item.sid == this.questionList[i].sid) {
          console.log(this.questionList[i])
          this.questionList[i].showAdd = true
          this.$forceUpdate()
        }
        arr.push(this.questionList[i].showAdd)
        var flag = arr.some((item) => {
          return item
        })
        this.showAll = flag
      }

      this.getNum()
    },

    // 进入试题篮
    goAssembly () {
      if (localStorage.getItem("localData") != null) {
        this.$router.push({
          path: "/works/assembly",
        })
      } else {
        this.$message.warning("请先去添加试题喔！")
      }
    },
    // 清空试题篮
    clear () {
      localStorage.removeItem("localData")
      localStorage.removeItem("localJson")

      for (let i in this.questionList) {
        this.questionList[i].showAdd = true
      }
      this.getLocalData = []
      this.quesStructures = []
      this.getNum()
    },

    // 试题篮题目列表
    getNum () {
      if (this.quesStructures.length !== 0) {
        var ary = []
        var kk = []
        for (let [k, v] of Object.entries(this.quesStructures)) {
          kk.push(k)
          ary.push(v.typeName ? v.typeName : "未设置题型")
        }
        var res = []
        res = ary.reduce(function (allNames, name) {
          if (name in allNames) {
            allNames[name]++
          } else {
            allNames[name] = 1
          }
          return allNames
        }, {})
        this.shopList = res
        this.noTestQuestions = false
      } else {
        this.shopList = []
        this.noTestQuestions = true
      }
    },

    showPublishModal (item) {
      this.publishVisible = true
      this.formData.exercisename = item.title
      this.commonHandle(item)
    },

    handleCancel () {
      this.reload()
    },

    closePublishDialog () {
      this.publishVisible = false
    },


  },

  created () {
    this.getDraftsList()

    // 本地获取localData
    if (localStorage.getItem("localData")) {
      this.getLocalData = localStorage.getItem("localData").split(",")
    } else {
      this.getLocalData = []
    }

    // 本地获取quesStructures
    if (localStorage.getItem("localJson")) {
      this.quesStructures = JSON.parse(localStorage.getItem("localJson"))
    } else {
      this.quesStructures = []
    }

    this.exercisetypeData = data.exercisetypeData


    this.getNum()
  },

  mounted () { },

  updated () { },

  beforeDestroy () { },
}
</script>

<style scoped lang="less">
.drafts {
  position: relative;
  height: calc(100vh - 14vh - 30px);
  min-height: 500px;
  padding: 20px;

  .drafts-header {
  }

  .drafts-main {
    overflow: auto;
    height: calc(100% - 6vh);
    .drafts-list {
      .drafts-list-item {
        padding: 1em;
        min-height: 4em;
        border-bottom: 1px dashed #ccc;
        display: flex;
        justify-content: space-around;
        align-items: center;

        div.title {
          width: 40%;
          padding-right: 2em;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            width: 4em;

            img {
              width: 100%;
              min-width: 3.5em;
            }
          }

          h3 {
            width: 78%;
            padding: 0 1em;
            font-size: 1.3em;
            font-weight: 700;
            margin-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #8a8a8a;
            text-align: left;
            display: inline-block;
          }
        }

        div:last-child {
          width: 60%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          a {
            padding: 0.3rem 0.5rem;
          }
        }
      }
    }

    .ant-empty {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .drafts-footer {
    height: 6vh;
    position: absolute;
    bottom: 20px;
    left: 20px;
    transform: translateY(50%);
  }
}

.question-preview {
  .anchor {
    position: absolute;
    top: 0;
    left: 0;
    width: 99%;
    padding: 16px 24px;
    border-radius: 4px 4px 0 0;
    overflow: hidden;
    background: #fff;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: 1px solid #e8e8e8;
    overflow: hidden;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .anchor .title {
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .anchor div:last-of-type {
    min-width: 16em;
  }
  .anchor span {
    border: 1px solid #40a9ff;
    color: #40a9ff;
    padding: 6px 6px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    margin: 0 1em;
  }
  .question-preview-item {
    margin-bottom: 10px;
  }

  .question-preview-item img {
    max-width: 100%;
  }

  .question-preview-item .ant-collapse {
    background-color: rgba(242, 250, 255, 1);
  }

  .question-preview-item:first-child {
    margin-top: 48px;
  }
  .question-preview-item p {
    line-height: 1.65;
    margin-bottom: 0;
  }
  .question-preview-item .typeAll {
    position: relative;
    border-top: 1px dashed rgb(221, 221, 221);
    padding-top: 10px;
  }
  .question-preview-item .inspect {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .question-preview-item .inspect > span {
    text-align: left;
    flex: 1;
  }

  .question-preview-item .shopHoverss {
    position: absolute;
    right: 10px;
    bottom: 0;
    z-index: 998;
  }

  .question-preview-item .shopHoverss span {
    border: 1px solid #40a9ff;
    color: #40a9ff;
    padding: 6px 6px;
    border-radius: 5px;
    font-size: 12px;
  }
  .question-preview-item .titleContent {
    overflow: hidden;
  }
  .question-preview-item .titleContent p.firstC {
    float: left;
    width: 23px;
    padding-top: 5px;
  }
  .question-preview-item .titleContent p.lastC {
    float: left;
    width: 75%;
    padding-top: 5px;
  }

  .question-preview-item .marker {
    position: absolute;
    right: 0;
    top: 0;
  }
  .question-preview-item .marker img {
    width: 22px;
  }
  /* 使用次数详情 */
  .popTitle {
    font-size: 16px;
    color: #000;
    font-weight: 600;
    display: flex;
  }
  .popTitle span {
    flex: 2;
    text-align: center;
  }
  .popDetail {
    display: flex;
  }
  .popDetail span {
    flex: 2;
    text-align: center;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/.question-preview-item .answer p span p {
    display: inline;
  }
}

.drafts-testShop {
  /* 试题蓝 */
  .testShop {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #40a9ff;
    position: fixed;
    right: 4%;
    bottom: 10%;
    cursor: pointer;
    z-index: 999;
  }
  .testShop img {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .testShop span {
    position: absolute;
    right: -5px;
    background: #e4393c;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    display: block;
    width: 23px;
    height: 23px;
    line-height: 23px;
    text-align: center;
  }
  .dropList {
    width: 300px;
    text-align: center;
    padding: 0;
  }
  .dropList .ant-dropdown-menu-item {
    padding: 0;
  }
  .dropList .cart-list li {
    overflow: hidden;
    border-bottom: 1px dashed #ddd;
    padding: 0 20px;
    cursor: text;
  }
  .dropList .cart-list li:last-child {
    border-bottom: none;
  }
  .dropList .notestPop {
    padding: 15px 0;
  }
  .dropList .cart-list p {
    float: left;
    padding: 10px 0 0;
  }
  .cart-list .p1 {
    width: 60%;
    text-align: right;
  }

  .dropList .testStyle {
    background: #40a9ff;
    width: 150px;
    display: inline-block;
    line-height: 40px;
    color: #fff;
  }
  .dropList .emptyStyle {
    background: #ddd;
    width: 150px;
    display: inline-block;
    line-height: 40px;
  }
}

/deep/.ant-collapse-content-box {
  background-color: rgba(242, 250, 255, 1);
}
</style>
<style scoped>
.question-preview-item .titleContent p.lastC >>> img {
  max-width: 100%;
}
</style>
